import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { IconButton } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import React from 'react';

export const Expansion: any = withStyles({
  root: {
    border: 'none',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const defaultSummaryHeight = 36;
export const ExpansionSummary: any = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderBottom: 'none',
    marginBottom: -1,
    minHeight: defaultSummaryHeight,
    maxHeight: defaultSummaryHeight,
    padding: '0px',
    '&$expanded': {
      minHeight: defaultSummaryHeight,
      maxHeight: defaultSummaryHeight,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

export const ExpansionDetails: any = withStyles(() => ({
  root: {
    padding: '0px',
  },
}))(MuiAccordionDetails);

export function CollapseButton(props: any) {
  const { open } = props;
  return (
    <IconButton {...props} id="expend">
      {open ? <ExpandMoreIcon /> : <ExpandLessIcon />}
    </IconButton>
  );
}
